import React, { useState, useEffect } from "react"
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  TextField,
  Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { MuiOtpInput } from 'mui-one-time-password-input'

import { setUser } from "../utils/auth"
import APIS from "../utils/APIS"
import queryString from "query-string"

const ValidateCode = () => {
  const navigate = useNavigate();
  const [alertMessage, setAlertMessage] = useState()

  const [resendCode, setResendCode] = useState(false)

  const [isValidRequest, setIsValidRequest] = useState(null)
  const [infos, setInfos] = useState({})
  useEffect(() => {
    const urlParams = queryString.parse(location.search)
    window.history.replaceState(null, null, window.location.pathname)
    if (urlParams.i && urlParams.email) {
      if (urlParams?.noValid === "dbff0d04-628a-47ce-960e-4a216b3ff3f0") {
        //on vient direct de la page signup
        setInfos({
          id : urlParams.i,
          email : urlParams.email
        })
        setIsValidRequest(true)
      } else {
        //on va vérifier que les infos sont correctes
        APIS.checkRegisterRecruiter({email : urlParams.email, id : urlParams.i}).then((result) => {
          if (result?.message === "checkRegisterRecruiter") {
            setInfos({
              id : urlParams.i,
              email : urlParams.email
            })
            setIsValidRequest(true)
          } else {
            setIsValidRequest(false)
          }
        })
      }
    } else {
      setIsValidRequest(false)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Validation | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          {isValidRequest === "final" &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Validation compte
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                mt={2}
                variant="body2"
              >
                Un email contenant un lien pour créer votre mot de passe a été envoyé.
              </Typography>
              <Box sx={{ py: 2 }}>
                <RouterLink to="/login">
                  <Button
                    color="primary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    endIcon={<ChevronRightIcon/>}
                  >
                    Se connecter
                  </Button>
                </RouterLink>
              </Box>
            </Box>
          }
          {isValidRequest === false &&
            <Box sx={{ mb: 3, textAlign:"center" }}>
              <Typography
                color="textBlack"
                variant="h2"
              >
                Validation compte
              </Typography>
              <Typography
                color="textPrimary"
                gutterBottom
                variant="body2"
              >
                Les informations ne sont pas valides
              </Typography>
            </Box>
          }
          {isValidRequest === true &&
            <Formik
              initialValues={{
                otp : '',
              }}
              validationSchema={Yup.object().shape({
                otp: Yup.string().required('Le code est requis'),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setAlertMessage("");
                const vals = { id : infos?.id, email: infos?.email, otp: values.otp }
                APIS.validCodeRecruiter(vals).then(result => {
                  if (result?.message === "validCodeRecruiter") {
                    APIS.askForNewPasswordEmail({email : infos?.email}).then(resultPassword => {
                      if (resultPassword?.message === "askForNewPasswordEmail") {
                        setIsValidRequest("final")
                      }
                    })
                  } else {
                    setAlertMessage("Code Incorrect");
                    setSubmitting(false);
                  }
                })

              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                setFieldValue,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 3, textAlign:"center" }}>
                    <Typography
                      color="textBlack"
                      variant="h2"
                    >
                      Validation compte
                    </Typography>
                    <Typography
                      color="textPrimary"
                      gutterBottom
                      variant="body2"
                    >
                      Nous avons envoyé un e-mail de confirmation à {infos?.email}
                    </Typography>
                  </Box>
                  <MuiOtpInput
                    length={6}
                    TextFieldsProps={{
                      placeholder: '-'
                    }}
                    value={values.otp}
                    onChange={(val) => { setFieldValue("otp", val)}}
                    onComplete={(e) => {
                      handleSubmit()
                    }}
                  />
                  {touched.otp && errors.otp && (
                    <Typography variant="body2" color="error" sx={{ mt: 2, textAlign:"center" }}>
                      {errors.otp}
                    </Typography>
                  )}
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                      endIcon={<ChevronRightIcon/>}
                    >
                      Suivant
                    </Button>
                  </Box>
                  <Box sx={{
                    fontSize:"16px",
                    textAlign:"center",
                    color : "text.black",
                    userSelect:"none"
                  }}>
                    {resendCode === false &&
                      <Link
                        sx={{cursor:"pointer"}}
                        onClick={() => {
                          APIS.resendCodeRecruiter({ id : infos?.id, email: infos?.email}).then((result) => {
                            if (result?.message === "resendCodeRecruiter") {
                              setResendCode(true)
                            } else {
                              alert("Erreur !")
                            }
                          })
                        }}
                      >
                        Renvoyez le code
                      </Link>
                    }
                    {resendCode === true &&
                      <b>Email envoyé !</b>
                    }
                  </Box>
                  {alertMessage && alertMessage.length > 0 && (
                    <Box
                      sx={{
                        pb: 1,
                        pt: 2
                      }}
                    >
                      <Typography
                        align="center"
                        color="red"
                        variant="body1"
                      >
                        {alertMessage}
                      </Typography>
                    </Box>
                  )}
                </form>
              )}
            </Formik>
          }
        </Container>
      </Box>
    </>
  );
};

export default ValidateCode;
